import { createFileRoute } from '@tanstack/react-router'

import { RolePage } from '#/modules/roles/role-page'

export const Route = createFileRoute('/_shell/roles/$roleId')({
  component: function RoleRoute() {
    const { roleId } = Route.useParams()
    return <RolePage roleId={roleId} />
  },
})
